import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=2daa973e&scoped=true&"
import script from "./banners.vue?vue&type=script&lang=js&"
export * from "./banners.vue?vue&type=script&lang=js&"
import style0 from "./banners.vue?vue&type=style&index=0&id=2daa973e&lang=scss&scoped=true&"
import style1 from "./banners.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./banners.vue?vue&type=style&index=2&id=2daa973e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa973e",
  null
  
)

export default component.exports